import {
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  faTimes,
  faTimesCircle,
} from "@fortawesome/pro-duotone-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CloseButtonProps } from "node_modules/react-toastify/dist/components";
import { IconProps, ToastContainer } from "react-toastify";
import { tv } from "tailwind-variants";

type IToastClassNameProps = {
  type?: TypeOptions;
  defaultClassName?: string;
  position?: ToastPosition;
  rtl?: boolean;
};

type TypeOptions = "info" | "success" | "warning" | "error" | "default";

type ToastPosition =
  | "top-right"
  | "top-center"
  | "top-left"
  | "bottom-right"
  | "bottom-center"
  | "bottom-left";

const toast = tv({
  slots: {
    toastContainer:
      "mb-5 flex items-center justify-center gap-10 rounded-sm bg-white p-10 text-secondary shadow-md",
  },
  variants: {
    variant: {
      success: {
        toastContainer: "bg-white",
      },
      error: {
        toastContainer: "bg-white",
      },
      warning: {
        toastContainer: "bg-white",
      },
      info: {
        toastContainer: "bg-white",
      },
      default: { toastContainer: "bg-white text-secondary" },
    },
  },
  defaultVariants: { variant: "success" },
});

const StyledToastContainer = () => {
  const getToastClassName = (
    props: IToastClassNameProps | undefined,
  ): string => {
    const type = props?.type;
    const { toastContainer } = toast({ variant: type });

    return toastContainer();
  };

  const renderCloseButton = (props: CloseButtonProps) => (
    <button onClick={props.closeToast}>
      <FontAwesomeIcon icon={faTimes} className="text-gray-dark" />
    </button>
  );

  const renderIcon = ({ type }: IconProps) => {
    switch (type) {
      case "success":
        return <FontAwesomeIcon icon={faCheckCircle} className="text-green" />;
      case "error":
        return <FontAwesomeIcon icon={faTimesCircle} className="text-red" />;
      case "info":
        return <FontAwesomeIcon icon={faInfoCircle} className="text-primary" />;
      case "warning":
        return (
          <FontAwesomeIcon icon={faExclamationCircle} className="text-orange" />
        );
      default:
        return <FontAwesomeIcon icon={faInfoCircle} className="text-primary" />;
    }
  };

  return (
    <ToastContainer
      toastClassName={getToastClassName}
      hideProgressBar
      className="m-10 w-[unset] max-w-[520px]"
      closeButton={renderCloseButton}
      autoClose={5000}
      icon={renderIcon}
    />
  );
};

export default StyledToastContainer;
